const todayConfig = {
    memberToday: {
        filterLayout: '',
        listLayout: 'TodayListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
            wr_type: 'post',
            type: 'post',
            wr: 1,
            pa: 0,
            to: 1,
            cnt: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getToday',
        isCategory: true,
        getCategoryFunc: 'getTodayCategory',
    },
    today: {
        filterLayout: 'TodayFilterDefaultLayout',
        listLayout: 'TodayListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
            wr_type: 'post',
            type: 'post',
            wr: 1,
            pa: 0,
            to: 1,
            cnt: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getToday',
        isCategory: true,
        getCategoryFunc: 'getTodayCategory',
        keyName: 'wr_id',
        deleteFunc: 'deleteToday',
        deleteApiParamsSet: {
            wr_type : 'post',
            type: 'post',
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    detailToday: {
        getFunc: 'getToday',
        detailApiParamSet: {
            type: 'post',
            wr_type: 'post',
            wr: 1,
            f: 1,
            to: 1,
            ha: 1,
            it: 'item',
            pa: 0,
            cnt: 1,
        },
        writeFunc: '',
        writeLayouts: ['TodayWriteDefaultLayout'],
        writeApiParamSet: {
        },
        parsingData: {
        },
        keyName: '',
        isCategory: true,
        getCategoryFunc: 'getTodayCategory',
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        deleteFunc: 'deleteToday',
        deleteApiParamsSet: {
            wr_type : 'post',
            type: 'post',
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    todayComment: {
        filterLayout: '',
        listLayout: 'TodayCommentListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getToday',
        listApiParamSet: {
            type: 'post',
            wr_type: 'comment',
            ip : 1,
            wr: 1,
            f: 1,
            it: 1, //아이템
            li: 1,
            cmt: 1,
            cnt: 1,
            lic:1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        directUrl: '',
        directType: '',
        keyName: '',
    },
    todayReplyComment: {
        filterLayout: '',
        listLayout: 'TodayReplyCommentListLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getToday',
        listApiParamSet: {
            type: 'post',
            wr_type: 'comment',
            ip : 1,
            wr: 1,
            f: 1,
            it: 1, //아이템
            li: 1,
            cmt: 1,
            cnt: 1,
            lic:1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        keyName: '',
    }
}

export default {
    methods: {
        returnTodayConfig(type) {
            return todayConfig[type];
        },
    },
    filterConfig: {
        mbid: { // 작성자 아이디
            type: 'query',
            classname: 'searchInput',
        },
        mbni: { // 작성자 닉네임
            type: 'query',
            classname: 'searchInput',
        },
        id: { // 게시글 번호
            type: 'query',
            classname: 'searchInput',
        },
        ist: { // 등급
            type: 'match',
            classname: 'filterRank',
        },
        se: { // 성별
            type: 'match',
            classname: 'filterSe',
        },
        cr: { // 등록일
            type: 'between',
            classname: 'filterDate'
        },
        ca: { // 카테고리
            type: 'match',
            classname: 'filterCate',
        }
    },
}
